import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTemplate } from '@/contexts/TemplateContext';

export interface BookingLocationOption {
  id: string;
  business_name: string | null;
  slug: string;
  location?: string | null;
  is_primary?: boolean;
}

interface LocationPickerProps {
  locations: BookingLocationOption[];
  value: string | null;
  onChange: (locationId: string) => void;
}

export const LocationPicker: React.FC<LocationPickerProps> = ({
  locations,
  value,
  onChange,
}) => {
  const { colors } = useTemplate();
  const { t } = useTranslation('booking');

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold" style={{ color: colors.colors.text }}>
          {t('location.selectTitle', { defaultValue: 'Choose a location' })}
        </h2>
        <p className="mt-1" style={{ color: colors.colors.textMuted }}>
          {t('location.selectDescription', {
            defaultValue: 'Select where you would like your appointment.',
          })}
        </p>
      </div>

      <div className="space-y-3">
        {locations.map((loc) => {
          const selected = value === loc.id;
          return (
            <button
              key={loc.id}
              type="button"
              onClick={() => onChange(loc.id)}
              className={`w-full text-left p-4 rounded-xl border-2 transition-colors ${
                selected ? 'border-primary' : 'border-border hover:border-primary/50'
              }`}
              style={{
                borderColor: selected ? colors.colors.primary : colors.colors.secondary,
                backgroundColor: colors.colors.background,
              }}
            >
              <div className="font-semibold" style={{ color: colors.colors.text }}>
                {loc.business_name || loc.slug}
              </div>
              {loc.location && (
                <div className="text-sm mt-1" style={{ color: colors.colors.textMuted }}>
                  {loc.location}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
